import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=120b30f9&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120b30f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('120b30f9')) {
      api.createRecord('120b30f9', component.options)
    } else {
      api.reload('120b30f9', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=120b30f9&scoped=true", function () {
      api.rerender('120b30f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/operationManagement/promotionManage/detail.vue"
export default component.exports